"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUserRegistrationMitek = exports.validateUserRegistrationIdentityMind = exports.receiveKYC = exports.confirmMitek = exports.RECEIVE_KYC = void 0;
var _apiActions = require("./apiActions");
var _sidePaneActions = require("./sidePaneActions");
var _snackbarActions = require("./snackbarActions");
var _kycActions = require("./kycActions");
var _userActions = require("./userActions");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var snackBarWarningSettings = {
  id: 'validateUserRegistrationError',
  timeout: 20000,
  type: 'warning'
};
var snackBarSuccessSettings = {
  id: 'validateUserRegistrationSuccess',
  timeout: 20000,
  type: 'success'
};
var RECEIVE_KYC = exports.RECEIVE_KYC = 'RECEIVE_KYC';
var receiveKYC = exports.receiveKYC = function receiveKYC(payload) {
  return {
    type: RECEIVE_KYC,
    payload: payload
  };
};
var validateUserRegistrationIdentityMind = exports.validateUserRegistrationIdentityMind = function validateUserRegistrationIdentityMind(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var validateUserRegistrationPayload, setUserConfigPayload, response, result, showWarningSnack;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(_kycActions.processingValidateUserRegistration);
            validateUserRegistrationPayload = payload.validateUserRegistrationPayload, setUserConfigPayload = payload.setUserConfigPayload;
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('ValidateUserRegistration', validateUserRegistrationPayload));
          case 1:
            response = _context.v;
            try {
              result = JSON.parse(response.result);
            } catch (error) {
              result = response.result;
            }
            showWarningSnack = function showWarningSnack(text) {
              dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBarWarningSettings), {}, {
                text: text
              })));
              dispatch((0, _sidePaneActions.closeKYCSidePane)());
            };
            if (result === false || result === null) {
              showWarningSnack("Validator isn't setup for the exchange. Please contact the exchange admin for help.");
            } else if (result === 'Unknown Validator Request' || result === 'Validator Not Connected') {
              showWarningSnack(result);
            } else if (result === 'Unable to validate') {
              showWarningSnack(result + '. Please contact the exchange admin for help.');
            } else if (result === 'Validator Call failed: The remote server returned an error: (500) Internal Server Error.') {
              showWarningSnack('There was a 500 Internal Server Error. Please contact the exchange admin for help.');
            } else if (result === 'Validator Call failed: Unable to connect to the remote server') {
              showWarningSnack('Our server-side verification service is currently unconfigured or down. Please contact the exchange admin for help.');
            } else if (result.ErrorMessage) {
              showWarningSnack('There was an error in processing your information. Be sure you are including all information required.');
            } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.ApiError) {
              showWarningSnack(result.ValidationAnswerData.ApiErrorDescription || result.ValidationAnswerData.ApiError);
            } else if (result.ValidationAnswerData) {
              handleSuccess(result, setUserConfigPayload, dispatch);
            }
            return _context.a(2, dispatch(_kycActions.finishedValidateUserRegistration));
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
function handleSuccess(result, setUserConfigPayload, dispatch) {
  var snackbarText;
  if (result.ValidationAnswerData.IsAccepted) {
    snackbarText = 'Your information has been accepted and is currently under review. Your verification status will be updated within 24-48 hours.';
  } else if (!result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.NeedsManualReview) {
    snackbarText = 'Your information has been accepted and is currently under review.';
  } else {
    snackbarText = 'Your information has been accepted and is currently under review.';
  }
  dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBarSuccessSettings), {}, {
    text: snackbarText
  })));
  dispatch((0, _sidePaneActions.closeKYCSidePane)());
}
var validateUserRegistrationMitek = exports.validateUserRegistrationMitek = function validateUserRegistrationMitek(payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var response, result, rawData, kycPayload;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch(_kycActions.processingValidateUserRegistration);
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('ValidateUserRegistration', payload));
          case 1:
            response = _context2.v;
            try {
              result = JSON.parse(response.result);
              rawData = JSON.parse(result.ValidationAnswerData.RawData);
            } catch (error) {
              result = response.result;
            }
            if (result.ValidationAnswerData) {
              if (result.ValidationAnswerData.IsAccepted && result.ValidationAnswerData.RedirectUrl) {
                kycPayload = {
                  urlParams: result.ValidationAnswerData.RedirectUrl
                };
                dispatch(receiveKYC(kycPayload));
              } else {
                handleError(result, rawData, dispatch);
              }
            } else {
              dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBarWarningSettings), {}, {
                text: 'Something went wrong. Please contact the Exchange Admin'
              })));
              dispatch((0, _sidePaneActions.closeKYCSidePane)());
            }
            dispatch(_kycActions.finishedValidateUserRegistration);
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var confirmMitek = exports.confirmMitek = function confirmMitek(setUserConfigPayload) {
  return function (dispatch) {
    dispatch((0, _kycActions.temporarilySetLevelIncreaseStatus)({
      levelIncreaseStatus: 'underReview'
    }));
    // may not need submitUserConfig, but callback to setUserConfig from backend doesn't seem to be configured on apexqa(2)
    dispatch((0, _userActions.setUserConfig)(setUserConfigPayload.UserId, setUserConfigPayload.UserName, [{
      Key: 'levelIncreaseStatus',
      Value: 'underReview'
    }], false));
    dispatch((0, _sidePaneActions.closeKYCSidePane)());
  };
};
function handleError(result, rawData, dispatch) {
  var snackbarText;
  if (result.ValidationAnswerData.IsAccepted && !result.ValidationAnswerData.RedirectUrl) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "No redirect url (params)"';
  } else if (rawData.frd.includes('[Fired] No remaining queries')) {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin and alert them of this Error: "[Fired] No remaining queries..."';
  } else {
    snackbarText = 'Something went wrong. Please contact the Exchange Admin';
  }
  dispatch((0, _snackbarActions.showSnack)(_objectSpread(_objectSpread({}, snackBarWarningSettings), {}, {
    text: snackbarText
  })));
  dispatch((0, _sidePaneActions.closeKYCSidePane)());
}